export default __webpack_public_path__ + "static/media/patterns.856b82c5.svg";